import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcDissatisfied = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.0002,
			cy: 10.0002,
			r: 7.85714,
			fill: "#415E96"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.08275 11.9841C7.08192 11.9853 7.08109 11.9865 7.08025 11.9877C7.08044 11.9875 7.08069 11.9872 7.081 11.9867C7.08305 11.984 7.08791 11.9776 7.09583 11.9681C7.11167 11.9491 7.13978 11.9175 7.18218 11.8774C7.26679 11.7972 7.40931 11.6818 7.62655 11.5633C8.05924 11.3273 8.8028 11.0712 10.0002 11.0712C11.1976 11.0712 11.9411 11.3273 12.3738 11.5633C12.591 11.6818 12.7336 11.7972 12.8182 11.8774C12.8606 11.9175 12.8887 11.9491 12.9045 11.9681C12.9124 11.9776 12.9173 11.984 12.9194 11.9867C12.9197 11.9872 12.9199 11.9875 12.9201 11.9878C13.0305 12.1485 13.2498 12.1912 13.4126 12.0827C13.5767 11.9733 13.621 11.7515 13.5116 11.5874L13.2145 11.7855C13.5116 11.5874 13.5115 11.5872 13.5113 11.5869L13.511 11.5864L13.5102 11.5853L13.5086 11.5829L13.5043 11.5768C13.5011 11.5722 13.4971 11.5667 13.4923 11.5602C13.4827 11.5473 13.4697 11.5306 13.4533 11.5108C13.4203 11.4712 13.373 11.4191 13.3094 11.3588C13.182 11.2381 12.9897 11.0856 12.7158 10.9363C12.1664 10.6366 11.3028 10.3569 10.0002 10.3569C8.69756 10.3569 7.83397 10.6366 7.28452 10.9363C7.01069 11.0856 6.81839 11.2381 6.69094 11.3588C6.62731 11.4191 6.58009 11.4712 6.5471 11.5108C6.53061 11.5306 6.51768 11.5473 6.50805 11.5602C6.50323 11.5667 6.49923 11.5722 6.49603 11.5768L6.4918 11.5829L6.49012 11.5853L6.48939 11.5864L6.48905 11.5869C6.48889 11.5872 6.48873 11.5874 6.78589 11.7855L6.48873 11.5874C6.37932 11.7515 6.42367 11.9733 6.58778 12.0827C6.75051 12.1912 6.96989 12.1485 7.08025 11.9878C7.07984 11.9883 7.07977 11.9884 7.08001 11.9881L7.08104 11.9866L7.08192 11.9853L7.08246 11.9845L7.08275 11.9841ZM12.9179 11.9845L12.9184 11.9853L12.9193 11.9866L12.9203 11.9881C12.9206 11.9884 12.9205 11.9883 12.9201 11.9878",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.85735,
			cy: 8.57122,
			r: .714286,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.143,
			cy: 8.57122,
			r: .714286,
			fill: "white"
		})
	]
});
export default SvgIcDissatisfied;
